// t() reads the page language, which the compiler cannot see, and this stays
// on screen while the language changes.
"use no memo";
import { t } from "../i18n";

export function CallHeading({
  children,
  name,
}: {
  children: string;
  name: string;
}) {
  // Keep the translated word order and isolate names in either writing direction.
  const [before, after] = t(children).split("{name}");
  return (
    <h1 id="invite-title">
      {before}
      <bdi className="call-invite-name">{name}</bdi>
      {after}
    </h1>
  );
}
